/**
 * Status Bar Component
 *
 * Bottom bar showing:
 * - Current chunk position
 * - Keyboard hints
 * - Auto-save status
 */

import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';

/**
 * Status Bar
 */
function StatusBar({ currentChunkIndex, totalChunks, progress }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'rgba(0,0,0,0.02)',
      }}
    >
      {/* Left: Chunk Position */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Chunk {currentChunkIndex + 1} of {totalChunks}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          •
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {progress.percentage}% complete
        </Typography>
      </Box>

      {/* Right: Keyboard Hints */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <KeyboardIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <KeyboardHint keys={['1-9']} action="Apply code" />
        <KeyboardHint keys={['N']} action="Next" />
        <KeyboardHint keys={['P']} action="Prev" />
        <KeyboardHint keys={['?']} action="Shortcuts" />
      </Box>
    </Box>
  );
}

/**
 * Keyboard Hint Pill
 */
function KeyboardHint({ keys, action }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {keys.map((key) => (
        <Chip
          key={key}
          label={key}
          size="small"
          sx={{
            height: 18,
            fontSize: '0.65rem',
            fontWeight: 600,
            bgcolor: 'rgba(0,0,0,0.08)',
            color: 'text.primary',
            '& .MuiChip-label': {
              px: 0.75,
            },
          }}
        />
      ))}
      <Typography variant="caption" color="text.secondary" sx={{ ml: 0.25, mr: 1 }}>
        {action}
      </Typography>
    </Box>
  );
}

export default StatusBar;
